export const decodeTrailerText = trailerText => {
    return trailerText != undefined ? Buffer.from(trailerText, 'base64').toString('utf-8') : "";
};

export const downloadData = (fileName, contentType, data) => {
    const a = document.createElement("a");
    a.style = "display: none";
    a.download = fileName;

    const blob = new Blob([data], {type: contentType})
    const url = window.URL.createObjectURL(blob);

    a.href = url;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
}